module.exports = __webpack_public_path__ + "img/mylender.a758f85.png";